<script>
    import addVariant from "src/utility/variant"
    import FormGroup from "./FormGroup.svelte";

    export let variant;
    export let label;
    export let checked;
    export let messages;
</script>

<FormGroup {variant} {messages}>
    <label class="pc__checkbox" use:addVariant={variant}>
        <input type="checkbox" bind:checked />
        {@html label}
    </label>
</FormGroup>